import React, { Fragment, useEffect, useState } from 'react';
import { Sport } from '~/web-frontend-components/line/matches/list/Sport';
import { MatchesList as MatchesListStore } from '~/web-frontend-core/store/line/MatchesList';
/** Представление списка матчей */
export const MatchesList = (props) => {
    const data = props.matchesListStore.getData(props.matchesFilter);
    const [, update] = useState();
    useEffect(() => {
        const updState = () => {
            update(Date.now());
        };
        props.matchesListStore.subscribe(updState);
        return () => { props.matchesListStore.unsubscribe(updState); };
    }, []);
    if (!data) {
        return <div className="result-no-events">{props.toLocale('NO_EVENTS')}</div>;
    }
    const handlers = Object.assign(Object.assign({}, props.matchesListStore.matches), props.matchHandlers);
    return <Fragment> {(data.sortedSportIds || []).map((sportID) => {
            var _a;
            const sport = { sportID, enSport: (_a = data.sports[sportID]) === null || _a === void 0 ? void 0 : _a.enSport };
            const getChampionshipURL = props.useSLUG ?
                (championship) => MatchesListStore.getChampionshipURL(props.mode, sport, championship) :
                (championship) => MatchesListStore.getChampionshipURL(props.mode, { sportID, enSport: '' }, { championshipID: championship.championshipID, enChampionship: '' });
            const getMatchURL = props.useSLUG ?
                (championship, match) => MatchesListStore.getMatchURL(props.mode, sport, championship, match) :
                (championship, match) => MatchesListStore.getMatchURL(props.mode, { sportID, enSport: '' }, { championshipID: championship.championshipID, enChampionship: '' }, { matchID: match.matchID, teams: { enTeam1: '', enTeam2: '', } });
            return <Sport championshipsHandlers={props.matchesListStore.championships} matchHandlers={handlers} getChampionshipURL={getChampionshipURL} getMatchURL={getMatchURL} championships={data.championships} sport={data.sports[sportID]} matchCommonProps={props.matchCommonProps} matches={data.matches} toLocale={props.toLocale} sportID={sportID} key={sportID}/>;
        })} </Fragment>;
};



// WEBPACK FOOTER //
// ./src/web-frontend-components/line/matches/List.jsx